import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

const faqData = [
  {
    question: "How can I place an order?",
    answer:
      "Select your school → Choose the required uniform items → Add them to the cart → Proceed to checkout and confirm your order.",
  },
  {
    question: "How can I track my order?",
    answer:
      "You can track your order from the Track Order section in your account to see the current delivery status.",
  },
  {
    question: "How long does delivery take?",
    answer:
      "Delivery usually takes 2–5 working days depending on your location.",
  },
  {
    question: "How can I cancel my order?",
    answer:
      "You can cancel your order from the Order Details page by clicking the Cancel Order button.",
  },
  {
    question: "What should I do if I receive the wrong size?",
    answer:
      "Please contact our support team through the Help Center or customer support.",
  },
  {
    question: "Can I change my delivery address after placing the order?",
    answer:
      "Address changes may be possible before the order is shipped.",
  },
  {
    question: "Who can I contact for support?",
    answer:
      "You can contact our Customer Support Team through the Help Center.",
  },
];

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const navigate = useNavigate();

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="faq-container">
      
      {/* Back Button */}
      <button
        className="btn btn-md d-flex align-items-center gap-2 fw-bold text-muted border-0 bg-transparent mb-3"
        onClick={() => navigate("/")}
      >
        <FaArrowLeft /> Back
      </button>

      <h1>Help Center - FAQ</h1>

      {faqData.map((faq, index) => (
        <div
          key={index}
          className={`faq-item ${activeIndex === index ? "active" : ""}`}
        >
          <div
            className="faq-question"
            onClick={() => toggleFAQ(index)}
          >
            {faq.question}
          </div>

          {activeIndex === index && (
            <div className="faq-answer">{faq.answer}</div>
          )}
        </div>
      ))}
    </div>
  );
};

export default FAQ;